import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Button, Grid, IconButton } from "@mui/material";
import { LatexEditor } from "../../../../LatexEditor";
import { Add, Close } from "@mui/icons-material";

interface ConfigFieldsProps {
	prefix?: string;
}

export default function ConfigFields({ prefix }: ConfigFieldsProps) {
	const { control } = useFormContext();
	const {
		fields: fieldsConfig,
		append: appendConfig,
		remove: removeConfig,
	} = useFieldArray({
		control,
		name: `${prefix}answer_config`,
	});

	const onAddConfig = () => appendConfig({ label: "" });

	const onRemoveConfig = (index: number) => removeConfig(index);

	return (
		<>
			{fieldsConfig.map((field, i) => (
				<Grid container key={field.id} alignItems={"center"} wrap={"nowrap"} item sx={{ marginBottom: "20px" }}>
					<LatexEditor controllerName={`${prefix}answer_config.${i}.label`} height={"64px"} />
					<Grid item sx={(theme) => ({ paddingLeft: theme.spacing(2) })}>
						<IconButton disabled={fieldsConfig.length < 2} onClick={() => onRemoveConfig(i)}>
							<Close />
						</IconButton>
					</Grid>
				</Grid>
			))}
			<Button variant={"text"} size={"small"} endIcon={<Add fontSize={"small"} />} onClick={onAddConfig}>
				Добавить вариант
			</Button>
		</>
	);
}
